import type { ApiResponse } from "@/types";

import { BaseApi } from "../base.api";
import type { JournalStudent } from "../journal/types";
import type { GradeComponentType } from "../live-courses/types";

export interface GradeBreakdownItem {
  type: GradeComponentType;
  /** Mavjud bo'lmagan bo'laklar tashlangandan keyingi haqiqiy vazn (%). */
  weight: number;
  score: number;
  weighted: number;
}

/** Jonli kurs bo'yicha o'quvchining hisoblangan yakuniy bahosi. */
export interface CourseGrade {
  id: number;
  courseId: number;
  studentId: number;
  finalScore: number;
  attendancePercent: number;
  breakdown: GradeBreakdownItem[] | null;
  passed: boolean;
  certificateIssued: boolean;
  computedAt: string | null;
  student?: JournalStudent;
}

/** Qayta hisoblashga beriladigan, qo'lda qo'yilgan faollik ballari. */
export interface ParticipationScore {
  studentId: number;
  score: number;
}

export interface ComputeGradesData {
  participation?: ParticipationScore[];
}

/** LIVE kurslarning yakuniy baholari (vaznli baholash sxemasi dvigateli). */
export class GradesApi extends BaseApi {
  private readonly baseUrl: string = "/grades";

  /** Har bir faol o'quvchining yakuniy bahosini qayta hisoblaydi. */
  compute(courseId: number, data: ComputeGradesData = {}) {
    return this.request.post<CourseGrade[], ApiResponse<CourseGrade[]>>(
      `${this.baseUrl}/courses/${courseId}/compute`,
      data,
    );
  }

  /** Kursning baho daftari (hamma o'quvchilar). */
  getGradebook(courseId: number) {
    return this.request.get<CourseGrade[], ApiResponse<CourseGrade[]>>(
      `${this.baseUrl}/courses/${courseId}`,
    );
  }

  /** Joriy o'quvchining yakuniy bahosi — birinchi hisobdan oldin `null`. */
  getMine(courseId: number) {
    return this.request.get<CourseGrade | null, ApiResponse<CourseGrade | null>>(
      `${this.baseUrl}/courses/${courseId}/me`,
      { skipErrorToast: true },
    );
  }
}

export const gradesApi = new GradesApi();
